"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FontAwesome_1 = __importDefault(require("../../../Icon/FontAwesome"));

var Image_1 = __importDefault(require("../../../Icon/Image"));

var ReactIcon_1 = __importDefault(require("../../../Icon/ReactIcon")); // See IconSource


var API_TO_ICON_MAP = Object.freeze({
  fa: FontAwesome_1.default,
  img: Image_1.default,
  react: ReactIcon_1.default
});
exports.default = API_TO_ICON_MAP;